module.exports = "pegasus_template/assets/precision-logo.png";